import React, { useContext } from 'react';
import { Box, Text, ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import { ChartSwatch } from './ChartFigure';
import ChartLink from './ChartLink';
import SegmentBar from './SegmentBar';

// How money split by payment method. `methods` comes from paymentMethods, so a method keeps its
// color wherever it appears and methods with nothing in them are already gone.
//
// With no methods it draws nothing, unless `keepSpace` is set: then an empty track and a blank
// legend line hold its place, so a chart that switches weeks on hover doesn't move what's below it.
const MethodBar = ({ methods, amount, href, keepSpace }) => {
    const theme = useContext(ThemeContext);
    if (methods.length === 0) {
        if (!keepSpace) return null;
        return (
            <Box gap="xsmall" aria-hidden>
                <Box height="10px" round="3px" background="chart-muted" />
                <Text>{'\u00a0'}</Text>
            </Box>
        );
    }
    return (
        <Box gap="xsmall">
            <SegmentBar
                segments={methods.map((method) => ({
                    key: method.key,
                    value: method.share,
                    title: `${method.label}: ${amount(method)}`,
                    color: normalizeColor(method.color, theme),
                }))}
            />
            <Box direction="row" wrap gap={{ row: 'xxsmall', column: 'small' }}>
                {methods.map((method) => (
                    <Box key={method.key} direction="row" gap="xsmall" align="center">
                        <ChartSwatch color={method.color} />
                        <ChartLink href={href(method)} label={<Text color="text">{`${method.label} ${amount(method)}`}</Text>} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default MethodBar;
